module.exports = __webpack_public_path__ + "img/logo.a552dd1a.svg";